// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__26IwI","ranges":"BmiRanges_ranges__3KodW"};